<!-- LandUseModal.vue -->
<template>
  <div class="modal fade land-use-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-uppercase" id="myLargeModalLabel">Possible Land Use Types</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <p class="fw-bold">Possible Land Use Types In Kenya</p>

            <div class="col-12 mb-3">
              <p>In the context of Kenyan lands, our system identifies various prevalent land use types, tailored to meet the diverse needs of the population and the economy. This information serves as a valuable tool for users, aiding in the systematic classification of land based on its intended use.</p>
            </div>

            <!-- First Column -->
            <div class="col-6">
              <ul>
                <li><strong>Residential:</strong>
                  <ul>
                    <li>Single-family homes</li>
                    <li>Multi-family dwellings</li>
                    <li>Gated communities</li>
                  </ul>
                </li>

                <li><strong>Commercial:</strong>
                  <ul>
                    <li>Retail spaces</li>
                    <li>Office buildings</li>
                    <li>Shopping centers</li>
                  </ul>
                </li>

                <li><strong>Industrial:</strong>
                  <ul>
                    <li>Manufacturing plants</li>
                    <li>Warehouses</li>
                    <li>Industrial parks</li>
                  </ul>
                </li>

                <li><strong>Agricultural:</strong>
                  <ul>
                    <li>Crop cultivation</li>
                    <li>Livestock farming</li>
                    <li>Agro-processing facilities</li>
                  </ul>
                </li>

                <li><strong>Institutional:</strong>
                  <ul>
                    <li>Schools and educational institutions</li>
                    <li>Hospitals and healthcare facilities</li>
                    <li>Government offices and facilities</li>
                  </ul>
                </li>

                <li><strong>Recreational:</strong>
                  <ul>
                    <li>Parks and green spaces</li>
                    <li>Sports complexes</li>
                    <li>Entertainment venues</li>
                  </ul>
                </li>
              </ul>
            </div>

            <!-- Second Column -->
            <div class="col-6">
              <ul>
                <li><strong>Transportation:</strong>
                  <ul>
                    <li>Roads and highways</li>
                    <li>Airports</li>
                    <li>Railways</li>
                  </ul>
                </li>

                <li><strong>Conservation and Natural Reserves:</strong>
                  <ul>
                    <li>National parks</li>
                    <li>Wildlife reserves</li>
                    <li>Forest reserves</li>
                  </ul>
                </li>

                <li><strong>Tourism and Hospitality:</strong>
                  <ul>
                    <li>Hotels and resorts</li>
                    <li>Tourist attractions</li>
                    <li>Hospitality zones</li>
                  </ul>
                </li>

                <li><strong>Mining and Extractive Industries:</strong>
                  <ul>
                    <li>Quarrying</li>
                    <li>Mining sites</li>
                    <li>Extractive industry zones</li>
                  </ul>
                </li>

                <li><strong>Mixed-Use Developments:</strong>
                  <ul>
                    <li>Areas combining residential, commercial, and recreational elements</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a href="#" target="_blank" type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-secondary waves-effect waves-light">
            Close
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandUseModal'
}
</script>

<style scoped>
/* Add any specific styling for the modal if needed */
</style>